import { storage } from 'lib';
import { ISignUpUser } from 'types';

export const SIGN_UP_USER_KEY = 'kf_sign_up_user';

const SignUpService = {
  setUser: (signUpUser: ISignUpUser) => storage.setItem(SIGN_UP_USER_KEY, JSON.stringify(signUpUser)),
  getUser: (): ISignUpUser | null => JSON.parse(storage.getItem(SIGN_UP_USER_KEY)),
  clearUser: () => storage.removeItem(SIGN_UP_USER_KEY),
};

export default SignUpService;
